// The ledger store, through Supabase. Every call runs as the signed-in person; the database's
// row-level security and the save_ledger checks do the rest.
import { sb } from './supabase';
import type { LedgerStore, LoadResult, SaveResult } from '../core/importFlow';

export const supabaseStore: LedgerStore = {
  async load() {
    const { data, error } = await sb().rpc('load_ledger');
    if (error) throw new Error(error.message);
    return data as LoadResult;
  },
  async save(a) {
    const { data, error } = await sb().rpc('save_ledger', {
      p_base_rev: a.baseRev, p_doc: a.doc, p_history: a.history, p_replace_history: false,
      p_hourly: a.hourly, p_manual: a.manual, p_fx_manual: a.fxManual, p_file_extra: a.fileExtra,
    });
    if (error) throw new Error(error.message);
    return data as SaveResult;
  },
  async keepUpload(u) {
    const { error } = await sb().from('imports').insert(u);
    if (error) throw new Error(error.message);
  },
};
